export const HIDE_HOME_BANNER_KEY = 'org.decentraland.governance.home_banner.hide'
export const HIDE_PROJECTS_BANNER_KEY = 'org.decentraland.governance.projects_banner.hide'
export const HIDE_DELEGATE_BANNER_KEY = 'org.decentraland.governance.delegate_banner.hide'
export const SHOW_DISCORD_MODAL_KEY = 'org.decentraland.governance.link_discord_modal.show_data'
export const HIDE_CONNECT_ACCOUNTS_BANNER_KEY = 'org.decentraland.governance.connect_accounts_banner.hide'
export const ACTION_BOX_EXPANDED_STATE_KEY = 'org.decentraland.governance.action_box.expanded'
export const PROFILE_POP_UP_LOCAL_STORAGE_KEY = 'org.decentraland.governance.profile-pop-up-dismissed'
export const NEWSLETTER_SUBSCRIPTION_KEY = 'org.decentraland.governance.newsletter_subscription'
export const ANONYMOUS_USR_SUBSCRIPTION = 'anonymous_subscription'
export const HIDE_NEWSLETTER_SUBSCRIPTION_KEY = 'org.decentraland.governance.newsletter_subscription.hide'
export const NOTIFICATIONS_NEW_FEATURE_DISMISSED_LOCAL_STORAGE_KEY =
  'org.decentraland.governance.notifications-new-feature-dismissed'
export const PROJECT_UPDATES_LATEST_CHECK = 'org.decentraland.governance.projects.updates.latest_check'
